import React from 'react';
export const QuoteMarks = ({ className }) => {
    return (React.createElement("svg", { width: "156", height: "137", viewBox: "0 0 156 137", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: className },
        React.createElement("path", { d: "M18.9 113.4V78.3C18.9 45 34.8 30.9 65.1 28.5L69 44.1C50.7 47.4 42 56.7 43.5 72H58.8V113.4H18.9Z", fill: "currentColor" }),
        React.createElement("path", { d: "M74.9 113.4V78.3C74.9 45 90.8 30.9 121.1 28.5L125 44.1C106.7 47.4 98 56.7 99.5 72H114.8V113.4H74.9Z", fill: "currentColor" })));
};
